import { Component, OnInit } from '@angular/core';
import {NavigatorService} from '../../services/navigatorService/navigator.service';
import {UserService} from '../../services/api-handlers/userService/user.service';
import {BootstrapNotifyService} from '../../services/bootstrap-notify/bootstrap-notify.service';
import {CacheService} from '../../services/cacheService/cache.service';
import {SharedFormService} from "../../services/shared-form.service";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {HttpEventType} from "@angular/common/http";
import { environment as env } from '../../../environments/environment';
import {IResponse} from "../../interfaces/iresponse";
declare const $: any;

@Component({
  selector: 'app-sign-up',
  templateUrl: './sign-up.component.html',
  styleUrls: ['./sign-up.component.css']
})
export class SignUpComponent implements OnInit {
  step: any = 1;
  submitted: any = false;
  fieldTextType: boolean;
  fileUploadProgress: string = null;
  passRequirement = {
    passwordMinLowerCase: 1,
    passwordMinNumber: 1,
    passwordMinSymbol: 1,
    passwordMinUpperCase: 1,
    passwordMaxCharacters: 6
  };
  pattern = [
    `(?=([^a-z]*[a-z])\{${this.passRequirement.passwordMinLowerCase},\})`,
    `(?=([^A-Z]*[A-Z])\{${this.passRequirement.passwordMinUpperCase},\})`,
    `(?=([^0-9]*[0-9])\{${this.passRequirement.passwordMinNumber},\})`,
    `(?=(\.\*[\$\@\$\!\%\*\?\&])\{${
      this.passRequirement.passwordMinSymbol
      },\})`,
    `[A-Za-z\\d\$\@\$\!\%\*\?\&\.]{${
      this.passRequirement.passwordMaxCharacters
      },}`
  ]
    .map(item => item.toString())
    .join("");

  public signup = new FormGroup({
    Form1Details: new FormGroup({
      schoolName: new FormControl('', Validators.required),
      schoolAbbreviation: new FormControl('', (Validators.required, Validators.maxLength(5))),
      address: new FormControl('', Validators.required),
      localGovernmentArea: new FormControl('', Validators.required)
    }),
    Form2Details: new FormGroup({
      phoneNo: new FormControl('', Validators.required),
      email: new FormControl('', Validators.required),
      password: new FormControl('Pas1@5', (Validators.required, Validators.pattern(this.pattern)))
    }),
    Form3Details: new FormGroup({
      websiteUrl: new FormControl('', Validators.required),
      stateId: new FormControl('', (Validators.required, Validators.maxLength(2))),
      Session: new FormControl('2021/2022', Validators.required),
      term: new FormControl('', (Validators.required, Validators.maxLength(1)))
    })
  });
  loaders = {
    loading: false
  };

  public Locations = [];
  public loading = false;
  constructor(private userService: UserService, private navigatorService: NavigatorService,
              private cacheService: CacheService,
              private bootstrapService: BootstrapNotifyService, private sharedFormService: SharedFormService, private navigationService: NavigatorService) {
  }

  ngOnInit(): void {
    // this.getLocations();
    this.getSchools();
  }

  get Form1Details() {
    return this.signup.controls['Form1Details']['controls'];
  }

  public submit() {
    if(this.signup.controls.Form3Details.invalid && this.step == 3) {
      return this.bootstrapService.warning('Ensure Email Address, Kyc Document Input Fields are' +
        ' Filled!!!');
    }
    const signupObject =
      { schoolName: this.signup.value.Form1Details.schoolName,
        schoolAbbreviation: this.signup.value.Form1Details.schoolAbbreviation,
        address: this.signup.value.Form1Details.address,
        localGovernmentArea: this.signup.value.Form1Details.localGovernmentArea,
        phoneNo: this.signup.value.Form2Details.phoneNo,
        email: this.signup.value.Form2Details.email,
        password: this.signup.value.Form2Details.password,
        websiteUrl: this.signup.value.Form3Details.websiteUrl,
        stateId: this.signup.value.Form3Details.stateId,
        Session: this.signup.value.Form3Details.Session,
        term: this.signup.value.Form3Details.term
        // KycDocument: this.signup.value.Form3Details.KycDocument
      };
    this.loading = true;
    this.userService.docUpload(signupObject).subscribe((res: any) => {
      console.log('Signup Full Data', signupObject);
      localStorage.setItem(env.SIGNUP, JSON.stringify(signupObject.email));
      this.loading = false;
      this.bootstrapService.success(res.message|| 'Successful');
      this.navigatorService.navigateUrl('/thank-you');
    }, error => {
      this.loading = false;
      console.log('Signup Error Data', signupObject);
      console.info('Error with Sign Up Form ', error);
      localStorage.setItem(env.SIGNUP, JSON.stringify(signupObject.email));
      this.bootstrapService.error(error.error.errors, error.error.status);
      /*this.bootstrapService.error(error.status || 'Unable to Process Signup');*/
      this.loaders.loading = false;
    });
  }

  /*public submit() {
    if(this.signup.controls.Form3Details.invalid && this.step == 3) {
      return this.bootstrapService.warning('Ensure Email Address, Kyc Document Input Fields are' +
        ' Filled!!!');
    }
    // console.log('signupdata',this.signup.value.Form1Details.SchoolName);
    console.log('signupdata', this.signup.value.Form1Details.SchoolName);
    const signupObject =
      { schoolName: this.signup.value.Form1Details.schoolName,
        schoolAbbreviation: this.signup.value.Form1Details.schoolAbbreviation,
        address: this.signup.value.Form1Details.address,
        localGovernmentArea: this.signup.value.Form1Details.localGovernmentArea,
        phoneNo: this.signup.value.Form2Details.phoneNo,
        email: this.signup.value.Form2Details.email,
        password: this.signup.value.Form2Details.password,
        websiteUrl: this.signup.value.Form3Details.websiteUrl,
        stateId: this.signup.value.Form3Details.stateId,
        Session: this.signup.value.Form3Details.Session,
        term: this.signup.value.Form3Details.term
      // KycDocument: this.signup.value.Form3Details.KycDocument
        };

    this.fileUploadProgress = '0%';
      this.userService.docUpload({
        signupObject,
        reportProgress: true,
        observe: 'res'
      }).subscribe((res: any) => {
        console.log('Signup Full Data', signupObject);
        if(res.type === HttpEventType.UploadProgress) {
          this.fileUploadProgress = Math.round(res.loaded / res.total * 100) + '%';
          console.log(this.fileUploadProgress);
        } else if(res.type === HttpEventType.Response) {
          this.fileUploadProgress = '';
          console.log('File Upload', res.body);
          // alert('Form and File Uploaded SUCCESS !!');
        }
        this.bootstrapService.success(res.message|| 'Successful');
        this.navigatorService.navigateUrl('/thank-you');
      }, error => {
        console.log('Signup Error Data', signupObject);
        console.info('Error with Sign Up Form ', error);
        this.bootstrapService.error(error.error.message || 'Unable to Process Signup');
        this.loaders.loading = false;
      });
  }*/

  /*public signUp2() {
    /!*if (!this.signup.SchoolName || !this.signup.SchoolShortCode || !this.signup.Address) {
      return this.bootstrapService.error('Ensure School Name, School Short Code and Address Input Fields are Filled!!!');
    } else {*!/
      this.loaders.loading = true;
      this.step = this.step + 1;
      this.sharedFormService.signupData = this.signup;
      console.log('Data from SignUP1 Page', this.signup);
      // this.navigationService.navigateUrl('/sign-up2');
      this.loaders.loading = true;
      this.userService.signUp(this.signup).subscribe((res: any) => {
        console.log('Signup Full Data', this.signup);
        this.bootstrapService.success(res?.description, res?.code);
        this.navigatorService.navigateUrl('/thank-you');
      }, error => {
        console.info('Error with Sign Up Form ', error);
        this.bootstrapService.error(error.error.message || 'Unable to Process Signup');
        // this.bootstrapService.error(error.error.description, error.error.code);
        this.loaders.loading = false;
    });
      // this.router.navigate(["/online-admissions/preview"]);
    }*/
  /*}*/

  public changeFormStep() {
    this.submitted = true;
    const PasswordValid = this.signup.value.password;
    if(this.signup.controls.Form1Details.invalid && this.step == 1) {
      console.log('Form 1 Details', this.signup.controls.Form1Details);
      return this.bootstrapService.warning('Ensure School Name, School Short Code and Address Input Fields are' +
        ' Filled!!!');
    }
    if(this.signup.controls.Form2Details.invalid && this.step == 2) {
      console.log('FOrm2Details', this.signup.controls.Form2Details);
      return this.bootstrapService.warning('Ensure Phone Number, Email and Password Input Fields are' +
        ' Filled!!!');
    }
    /*if(this.submitted && this.signup.controls.Form2Details.password.errors?.required){
    }*/
    if(this.signup.controls.Form3Details.invalid && this.step == 3) {
      return this.bootstrapService.warning('Ensure Website URL, State ID, Session and Term Input Fields are' +
        ' Filled!!!');
    }
    this.step = this.step + 1;
  }

  onFileChange(event) {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      this.signup.patchValue({
        fileSource: file
      });
    }
  }

  public getSchools(): void {
    this.userService.getSchools().subscribe((response: IResponse) => {
      this.Locations =  response.result;
    }, error => {
      this.bootstrapService.error(error.error.message || 'Unable to provide list of Locations');
      /*this.bootstrapService.error(error.error.description, error.error.code);*/
    });
  }

  public toggleFieldTextType() {
    this.fieldTextType = !this.fieldTextType;
  }

}
